export default "__VITE_ASSET__BEGtIzMa__"